<template>
    <auto-height :margin="10" class="p-2 d-flex flex-column">
        <div class="d-flex list-header mb-2">
            <input-debounced
                    v-model="search"
                    :clearable="true"
                    :autofocus="true"
                    placeholder="Search"
                    class="search-bar"
            ></input-debounced>
            <div class="d-flex">
                <button class="btn btn-purple ml-1" @click="refreshList">
                    <i class="fas fa-sync" :class="{'fa-spin': isListRefreshingActive}"></i>
                </button>
                <button class="btn btn-purple ml-1" @click="create">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
        </div>
        <contact-list
                ref="list"
                :url="urlWithFilters"
                @refresh-start="onListRefreshStarted"
                @refresh-finish="onListRefreshFinished"
                @change="onCurrentChange"
                v-slot:default="scope"
                class="list overflow-auto"
        >
            <contact-list-item
                    v-bind="scope"
                    class="mb-2 d-flex item"
                    @edit="onEdit"
            ></contact-list-item>
        </contact-list>
    </auto-height>
</template>

<script>
  import ContactList from '../../../components/contact-list/list';
  import ContactListItem from './list-item';
  import {addQueryParams} from "../../../libs/url";
  import AutoHeight from "../../../components/auto-height";

  export default {
    components: {
      ContactList,
      ContactListItem,
      AutoHeight,
    },

    props: {
      indexUrl: String,
      addUrl: String,
    },

    data() {
      return {
        search: null,
        filters: {},
        isListRefreshingActive: false,
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.indexUrl, this.filters);
      },
    },

    watch: {
      search(value) {
        const filters = _.omit(this.filters, ['search']);
        if (value) {
          filters.search = value;
        }
        this.filters = filters;
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refreshList() {
        this.$refs.list.refresh();
      },

      /**
       * @return {undefined}
       */
      create() {
        eventBus.$emit('show-add-contact-list-dialog', this.addUrl);
      },

      /**
       * @return {undefined}
       */
      onListRefreshStarted() {
        this.isListRefreshingActive = true;
      },

      /**
       * @return {undefined}
       */
      onListRefreshFinished() {
        this.isListRefreshingActive = false;
      },

      /**
       * @param {object|null}item
       * @event contact-list-current-change
       */
      onCurrentChange(item) {
        eventBus.$emit('contact-list-current-change', item);
      },

      /**
       * @param {object}item
       * @event show-edit-contact-list-dialog
       */
      onEdit(item) {
        eventBus.$emit('show-edit-contact-list-dialog', item.editUrl);
      },
    },
  }
</script>
